import { z } from 'zod';

import { FabricatorMemberFormSchema } from '@/lib/data/domains/fabricator-member';

// Shared base fields used for both the update-only form and the create form
// (create additionally collects the fabricator's first member)
const fabricatorBaseSchema = z.object({
  id: z.string(),
  concurrencyToken: z.string().optional(),
  name: z.string(),
  website: z.string(),
  brand: z.object({
    id: z.string(),
    name: z.string(),
  }),
  region: z.object({
    id: z.string(),
    name: z.string(),
  }),
  defaultRoles: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
    }),
  ),
  d365CustomerId: z.string(),
  hideRebateAndGrowthTargetSoW: z.boolean(),
});

const validateFabricatorFields = (data: any, ctx: any) => {
  if (!data.name || !data.name.trim()) {
    ctx.addIssue({
      path: ['name'],
      message: 'Fabricator is required',
      code: 'custom',
    });
  }

  if (!data.website || !data.website.trim()) {
    ctx.addIssue({
      path: ['website'],
      message: 'Website is required',
      code: 'custom',
    });
  }

  if (!data.brand.id) {
    ctx.addIssue({
      path: ['brand'],
      message: 'Brand is required',
      code: 'custom',
    });
  }

  if (!data.region.id) {
    ctx.addIssue({
      path: ['region'],
      message: 'Region is required',
      code: 'custom',
    });
  }

  if (data.defaultRoles.length === 0) {
    ctx.addIssue({
      path: ['defaultRoles'],
      message: 'Role is required',
      code: 'custom',
    });
  }
};

export const FabricatorFormSchema = fabricatorBaseSchema.superRefine(
  validateFabricatorFields,
);

export const FabricatorCreateFormSchema = fabricatorBaseSchema
  .extend({
    firstMember: FabricatorMemberFormSchema,
  })
  .superRefine(validateFabricatorFields);
